<div class="filter_container">
  <div class="filter">
    <!-- L'autocomplétion Material devient un `app-select` : il porte sa propre
         recherche, son effacement et son chevron. -->
    <app-form-field label="Clients" class="filter_element">
      <app-select
        label="Sélectionner un client"
        trigger="field"
        selectionMode="single"
        [fullWidth]="true"
        [clearable]="true"
        [options]="optionsClients()"
        [selected]="clientsSelectionnes()"
        (selectionChange)="choisirClient($event)"
      />
    </app-form-field>

    <app-form-field label="Evènement" class="filter_element">
      <app-input [clearable]="true" [formControl]="filterForm.controls.rechercheEvenement" />
      @if (rechercheTropCourte()) {
        <span appFieldError>Minimum 3 caractères pour lancer la recherche</span>
      }
    </app-form-field>

    <!-- Adaptateur vers le `app-date-range-picker` du kit (largeur figée sur
         celle des champs voisins, cf. son SCSS). -->
    <app-plage-dates
      [startDate]="filterForm.controls.filtreDateDebut"
      [endDate]="filterForm.controls.filtreDateFin"
    ></app-plage-dates>

    <div class="toggles">
      <app-toggle
        [label]="estArchiveIsChecked() ? 'Archivé' : 'Non archivé'"
        [checked]="estArchiveIsChecked()"
        (checkedChange)="toggleEstArchiveChange()"
      />
      <app-toggle
        label="A redditionner uniquement"
        [checked]="aRedditionnerIsChecked()"
        (checkedChange)="toggleARedditionnerChange()"
      />
    </div>
  </div>
  <div class="nbr_evenement">
    <p>{{ evenements().totalCount }} évènement(s)</p>
  </div>
</div>
